import React, { Component } from "react";
import axios from "axios";
import { isGuid } from "../utils/utils";

export default class ReviewSites extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reviewSites: [],
    };
  }

  async ClickOnReviewSite(reviewSiteId) {
    const host = process.env.REACT_APP_API_BASE_URL;
    const clientId = this.props.urlData.clientId;
    const requestId = this.props.urlData.requestId;

    if (isGuid(requestId)) {
      const body = {};
      const headers = {
        "DAS-Guest-Subscription-Key":
          process.env.REACT_APP_API_SUBSCRIPTION_KEY,
      };

      await axios
        .post(
          `${host}/clickreviewsite?RequestId=${requestId}&ClientId=${clientId}&ReviewSiteId=${reviewSiteId}`,
          body,
          { headers }
        )
        .then((res) => {
          const reviewSiteData = res.data;
          window.location.replace(reviewSiteData.referenceUrl);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  async GetDealerSites(urlData) {
    const host = process.env.REACT_APP_API_BASE_URL;
    const clientId = this.props.urlData.clientId;
    const requestId = this.props.urlData.requestId;

    if (isGuid(clientId)) {
      const headers = {
        "DAS-Guest-Subscription-Key":
          process.env.REACT_APP_API_SUBSCRIPTION_KEY,
      };

      await axios
        .get(
          `${host}/reviewsites?RequestId=${requestId}&ClientId=${clientId}`,
          { headers }
        )
        .then((res) => {
          const dealerData = res.data;

          this.setState({
            reviewSites: dealerData,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  componentDidMount() {
    //Get dealer sites to show the list in the component
    this.GetDealerSites();
  }

  render() {
    return (
      <div>
        {this.state.reviewSites.map((reviewSite) => {
          return (
            <div key={reviewSite.id} className="review-site-container">
              <a href="#/" className="review-site-anchor">
                <div
                  className={
                    "review-site-image-" + reviewSite.name + "-container"
                  }
                  onClick={() => this.ClickOnReviewSite(reviewSite.id)}
                >
                  <img
                    alt={reviewSite.reviewSiteName}
                    className="review-site-image"
                    src={reviewSite.reviewSiteIconUrl}
                  ></img>
                  <div className="review-site-text">
                    {reviewSite.reviewSiteName}
                  </div>
                </div>
              </a>
            </div>
          );
        })}
      </div>
    );
  }
}
